/** Used as an action type when the presentation values need to be updated */
export const UPDATE_PRESENTATION_VALUES = 'UPDATE_PRESENTATION_VALUES'



// WEBPACK FOOTER //
// ./src/actions/presentationActionTypes.js